/* eslint-disable */
import React from 'react'
import { parse as parseTags } from 'himalaya'
import { Text, Platform } from 'react-native'

function parseAnnounce(content, emit = () => {}) {
  const parse = (content) => {
    return content.map((element, index) => {
      switch (element.type) {
        case 'text':
          return <Text key={index}>{element.content}</Text>
        break
        
        case 'element':
          let style = element.attributes.find(attribute => attribute.key == 'style')
          style = JSON.parse(style ? style.value : '{}')
        
          switch (element.tagName) {
            case 'if-mobile':
              return Platform.OS == 'web' ? null : parse(element.children)
            break
            
            case 'if-desktop':
              return Platform.OS != 'web' ? null : parse(element.children)
            break
            
            case 'rate-app':
              return (
                <Text key={index}
                      style={style}
                      onPress={emit('rate-app')}>
                  {parse(element.children)}
                </Text>
              )
            break
            
            case 'text':
              return (
                <Text key={index}
                      style={style}>
                  {parse(element.children)}
                </Text>
              )
            break
            
            case 'br':
              return <Text key={index}>{'\n'}</Text>
            break
            
            case 'store-name':
              return Platform.OS == 'ios' ? 'App Store' : 'Google Play'
            break
            
            default:
              return parse(element.children)
            break
          }
        break
      }
    })
  }
  
  return parse(parseTags(content))
}

function parseContent(content, advancedMode) {
  if (!advancedMode) {
    content = content.replace(/\s*<ambr>\s*/g, ' ')
  }
  
  content = content.replace(/\s*<ambr>\s*/g, '<br>')
  
  return content
}

export {
  parseAnnounce,
  parseContent,
}